import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  getRequestedWithdrawalToken,
  WithdrawalRequestActions,
} from "../redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import WithdrawalRequestTable from "./withdrawal_man_detail/withdrawalRequestTable";
import DatePicker from "react-datepicker";

export function WithdrawalRequest() {
  const dispatch = useDispatch();
  const searchTokenTransactionRef = useRef();

  const {
    withdrawalRefreshTokenList,
    search,
    searchText,
    fromDate,
    toDate,
  } = useSelector((state) => state.withdrawalRequest, shallowEqual);

  // State for the selected filter values
  const [transactionType, setTransactionType] = useState("All");

  const transactionTypeOptions = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "approve", label: "Approved" },
    { value: "decline", label: "Declined" },
  ];

  // Call API while filters or search text changes

  useEffect(() => {
    if (searchTokenTransactionRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(WithdrawalRequestActions.getWithdrawalRequestRefreshList());
        }
      };
      let input = searchTokenTransactionRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(
          WithdrawalRequestActions.getWithdrawalRequestSearchTextChange("")
        );
        input.value = "";
      };
    }
  }, []);

  useEffect(() => {
    if (withdrawalRefreshTokenList) {
      // Pass the selected filters to the API
      dispatch(
        getRequestedWithdrawalToken({
          search,
          searchText,
          fromDate,
          toDate,
        })
      );
    }
  }, [withdrawalRefreshTokenList]);

  const resetChanges = () => {
    setTransactionType("All");
    dispatch(WithdrawalRequestActions.resetFilters());
  };

  const handleToDateChange = (date) => {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999); // Set time to end of the day
    dispatch(WithdrawalRequestActions.toDateChanges(endOfDay));
  };
  const handleFromDateChange = (date) => {
    dispatch(WithdrawalRequestActions.fromDateChanges(date));
  };

  const onSearchTextChange = (e) => {
    dispatch(
      WithdrawalRequestActions.getWithdrawalRequestSearchTextChange(
        e.target.value
      )
    );
  };

  const onSelectChange = (key, setState) => (selectedOption) => {
    setState(selectedOption);

    dispatch(
      WithdrawalRequestActions.getWithdrawalRequestSelectTextChange({
        [key]: selectedOption, // Update only the specific key
      })
    );
  };

  return (
    <>
      <Card>
        <Row>
          <Col>
            <Card>
              <CardHeader title="Withdrawal Management"></CardHeader>
            </Card>
          </Col>
        </Row>
        <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
          <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
            <Row>
              <Col>
                <CardHeaderToolbar>
                  <Row className="d-flex align-items-center justify-content-end gap-4">
                    <Col lg={2} className="p-0">
                      <div
                        style={{ margin: "1px" }}
                        className="date-picker-input"
                      >
                        <DatePicker
                          selected={fromDate}
                          autoComplete="off"
                          placeholderText="From date"
                          onChange={(date) => handleFromDateChange(date)}
                          name="fromDate"
                          value={fromDate}
                          maxDate={new Date()}
                          dateFormat="MMM d, yyyy"
                        />
                      </div>
                    </Col>
                    <Col lg={2} className="p-0">
                      <div
                        style={{ margin: "1px" }}
                        className="date-picker-input"
                      >
                        <DatePicker
                          name="toDate"
                          placeholderText="To date"
                          autoComplete="off"
                          value={toDate}
                          dateFormat="MMM d, yyyy"
                          selected={toDate}
                          maxDate={new Date()}
                          onChange={(date) => handleToDateChange(date)}
                        />
                      </div>
                    </Col>
                    <Col lg={1} className="p-0">
                      <button
                        className="btn_new btn-sm filter-btn w-100"
                        type="button"
                        onClick={() => resetChanges()}
                      >
                        Reset
                      </button>
                    </Col>

                    <Col lg={2} className="p-0">
                      <div className="viral-events-dropdown">
                        <Select
                          value={transactionType}
                          placeholder="Select Action"
                          className="border-0 p-0 w-100"
                          classNamePrefix="phoSelect"
                          options={transactionTypeOptions}
                          onChange={onSelectChange(
                            "transaction_type",
                            setTransactionType
                          )}
                        />
                      </div>
                    </Col>
                    <form
                      autoComplete="off"
                      className="subheader_filter"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control"
                        value={searchText}
                        onChange={onSearchTextChange}
                        ref={searchTokenTransactionRef}
                      />
                    </form>
                  </Row>
                </CardHeaderToolbar>
              </Col>
            </Row>
          </div>
        </div>

        <WithdrawalRequestTable />
      </Card>
    </>
  );
}
